import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/Certifications.css";
import { signedAuthHeaders } from "../../api";
import { coverForCert } from "../../catalogCovers";

const Certifications = () => {
    const [earnedCerts, setEarnedCerts] = useState([]);
    const [availableCerts, setAvailableCerts] = useState([]);
    const [error, setError] = useState(null);

    const wallet = localStorage.getItem("user");

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                if (wallet) {
                    const headers = await signedAuthHeaders({ Accept: "application/json" });
                    const res = await fetch(`/api/certifications/user/${encodeURIComponent(wallet)}`, { headers });
                    const data = res.ok ? await res.json() : [];
                    if (!cancelled) {
                        setEarnedCerts(Array.isArray(data) ? data : []);
                    }
                } else if (!cancelled) {
                    setEarnedCerts([]);
                }
                const available = await fetch(`/api/certifications/available`);
                if (!available.ok) {
                    throw new Error(`Certificates unavailable (${available.status})`);
                }
                const templates = await available.json();
                if (!cancelled) {
                    setAvailableCerts(Array.isArray(templates) ? templates : []);
                    setError(null);
                }
            } catch (err) {
                if (!cancelled) {
                    setAvailableCerts([]);
                    setError(err.message || "Could not load certifications");
                }
            }
        };
        load();
        return () => {
            cancelled = true;
        };
    }, [wallet]);

    const titleOf = (cert) => cert.coursetitle || cert.courseTitle || cert.title;
    const dateOf = (cert) => cert.issueddate || cert.issuedDate || "";

    return (
        <div className="certification-container">
            <h1>Your Certifications</h1>
            {error && <p className="cert-error">{error}</p>}
            {earnedCerts.length === 0 ? (
                <p>You don’t have any certifications yet.</p>
            ) : (
                <div className="certification-list">
                    {earnedCerts.map(cert => (
                        <Link to={`/certificates/${cert.id}`} key={cert.id} className="cert-card">
                            <img className="cert-cover" src={coverForCert(cert)} alt="" />
                            <h2>{titleOf(cert)}</h2>
                            <p>{cert.description}</p>
                            <p><strong>Issued On:</strong> {dateOf(cert)}</p>
                        </Link>
                    ))}
                </div>
            )}

            <h2>Discover Certifications</h2>
            <p className="cert-intro">
                Each catalog learning plan has a matching certificate. Complete the grouped courses to earn it.
            </p>
            {availableCerts.length === 0 && !error ? (
                <p>No certificate templates yet.</p>
            ) : (
                <div className="certification-list">
                    {availableCerts.map(cert => (
                        <Link to={`/certificates/${cert.id}`} key={cert.id} className="cert-card">
                            <img className="cert-cover" src={coverForCert(cert)} alt="" />
                            <h3>{titleOf(cert)}</h3>
                            <p>{cert.description}</p>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Certifications;
